import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {FormControl, FormGroup, Validators, AbstractControl, ValidationErrors} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WebOnboardingService} from '../../_services/web-onboarding.service';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css'],
})
export class PasswordComponent implements OnDestroy {
  @Input() validationToken = '';
  @Input() references: any[] = [];
  @Output() saved = new EventEmitter<void>();

  form = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(50),
      Validators.pattern(/^\d+$/),
    ]),
    confirmPassword: new FormControl('', [Validators.required]),
  }, {validators: this.passwordMatchValidator});

  loading = false;
  errorMessage = '';
  hidePassword = true;
  hideConfirm = true;

  private destroy$ = new Subject<void>();

  constructor(private onboardingService: WebOnboardingService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');
    if (password && confirmPassword && password.value !== confirmPassword.value) {
      confirmPassword.setErrors({mismatch: true});
      return {mismatch: true};
    }
    return null;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    const data = {
      token: this.validationToken,
      references: this.references,
      password: this.form.value.password!,
    };

    this.onboardingService
      .saveReferences(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.loading = false;
          this.saved.emit();
        },
        error: (err) => {
          this.loading = false;
          const body = err.error;
          if (body?.errors?.length) {
            this.errorMessage = body.errors.map((e: any) => e.message).filter(Boolean).join('\n');
          } else if (body?.message) {
            this.errorMessage = body.message;
          } else {
            this.errorMessage = 'Error al guardar la contraseña. Intentá nuevamente.';
          }
        },
      });
  }
}
